import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import App from "./App"
import { initializeSentry } from "./sentry/instrument"
import * as serviceWorker from "./serviceWorker"

initializeSentry()

const PRELOAD_ERROR_KEY = "vite-preload-error-reload-count"
const MAX_RELOADS = 1 // You can adjust this number if you want more attempts
const reloadCount = Number(sessionStorage.getItem(PRELOAD_ERROR_KEY) || 0)

// IT-2015: When we encounter `Failed to fetch dynamically imported module: <file>-COsXAhcO.js
// https://vite.dev/guide/build.html#load-error-handling
if (reloadCount > MAX_RELOADS) {
  console.error("Vite preload error: Maximum reload attempts reached.")
  sessionStorage.removeItem(PRELOAD_ERROR_KEY)
} else {
  // The first time a preload error occurs, this listener will trigger a single reload.
  window.addEventListener("vite:preloadError", (event) => {
    // Reload so the user will get the latest version of the application.
    console.warn("Vite preload error detected. Attempting to reload the page...", event)

    sessionStorage.setItem(PRELOAD_ERROR_KEY, `${reloadCount + 1}`)
    window.location.reload()
  })
}

// Clear the flag on a successful initial load to reset the count.
// This handles cases where a previous session failed but the new one works.
window.onload = () => {
  sessionStorage.removeItem(PRELOAD_ERROR_KEY)
}

// Textbox zoom fix for iOS
if (
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  // Include ipad using desktop mode
  (/MacIntel/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
) {
  document
    .querySelector("meta[name='viewport']")
    ?.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1")
}

const root = createRoot(document.getElementById("root")!)

// StrictMode enables additional development behaviors (to find common bugs in
// your components). In practice, it means components will re-render an
// additional time
// https://react.dev/reference/react/StrictMode
root.render(
  <StrictMode>
    <App />
  </StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
